import { render, staticRenderFns } from "./works.vue?vue&type=template&id=6cbb5058&scoped=true&"
import script from "./works.vue?vue&type=script&lang=js&"
export * from "./works.vue?vue&type=script&lang=js&"
import style0 from "./works.vue?vue&type=style&index=0&id=6cbb5058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb5058",
  null
  
)

export default component.exports